module.exports = __webpack_public_path__ + "static/media/arrow-right.63b834e8.svg";